import { UseStandingsConf } from "./getStandings";
import { statSeason } from "./vars";

//Team Data includes W/L/T record and bye week


export function GetTeamRecord(props) {
  // t=Team abv
  const { data, isLoading, error } = UseStandingsConf();

  if (isLoading) return <div>Loading team data...</div>;
  if (error) return <div>Error loading team data: {error.message}</div>;

  //console.log("check this: " + props.t)

  const teamData = data?.body?.find((t) => t.teamAbv === props.t);
  if (!teamData) return <div>Team not found</div>;
  return (
    <div className="teamRecordCont">
      {teamData.wins || 0}-{teamData.loss || 0}
      {teamData.tie > 0 ? '-'+teamData.tie : ""}
    </div>
  );
}

export function getBye(team) {
  // t=Team abv
  const { data, isLoading, error } = UseStandingsConf();

  if (isLoading) return <div>Loading team data...</div>;
  if (error) return <div>Error loading team data: {error.message}</div>;

  const teamData = data?.body.find((t) => t.teamAbv === team);
  const byeWeek = teamData?.byeWeeks[statSeason];
  //console.log(byeWeek)
  if (!byeWeek) {
    return 3;
  }
  return byeWeek[0];
}